import { HttpErrorResponse } from '@angular/common/http';
import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateAnnouncementDto } from '../dtos/create-announcement-dto.interface';
import { GetAnnouncementDto } from '../dtos/get-announcement-dto.interface';
import { UpdateAnnouncementDto } from '../dtos/update-announcement-dto.interface';

export const announcementsActions = createActionGroup({
    source: '[Aumico-Core] announcementsActions',
    events: {
        'Get All Announcements': emptyProps(),
        'Get All Announcements Success': props<{ payload: GetAnnouncementDto[] }>(),
        'Get All Announcements Failed': props<{ payload: HttpErrorResponse }>(),

        'Create Announcement': props<{ payload: CreateAnnouncementDto }>(),
        'Create Announcement Success': props<{ payload: GetAnnouncementDto }>(),
        'Create Announcement Failed': props<{ payload: HttpErrorResponse }>(),

        'Update Announcement': props<{ payload: { id: string; changes: UpdateAnnouncementDto } }>(),
        'Update Announcement Success': props<{ payload: GetAnnouncementDto }>(),
        'Update Announcement Failed': props<{ payload: HttpErrorResponse }>(),

        'Delete Announcement': props<{ payload: string }>(),
        'Delete Announcement Success': props<{ payload: string }>(),
        'Delete Announcement Failed': props<{ payload: HttpErrorResponse }>(),

        'Get User Announcements': emptyProps(),
        'Get User Announcements Success': props<{ payload: GetAnnouncementDto[] }>(),
        'Get User Announcements Failed': props<{ payload: HttpErrorResponse }>(),

        'Dismiss Announcement': props<{ payload: string }>(),
        'Dismiss Announcement Success': emptyProps(),
        'Dismiss Announcement Failed': props<{ payload: HttpErrorResponse }>(),

        'Set Selected Announcement': props<{ payload: string | null }>(),
    },
});

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
